import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "RcZhr+",
    defaultMessage: "Newsletter",
    description: "newsletter page title",
  },
  subscribersTitle: {
    id: "tiheSk",
    defaultMessage: "Newsletter subscribers",
    description: "newsletter subscribers section title",
  },
  subscribersSubtitle: {
    id: "YVOuH3",
    defaultMessage: "Customers who opted into marketing emails",
    description: "newsletter subscribers section subtitle",
  },
  staffTitle: {
    id: "RDivjX",
    defaultMessage: "Staff email recipients",
    description: "staff notification recipients section title",
  },
  staffSubtitle: {
    id: "oZLE7+",
    defaultMessage: "Staff members subscribed to store email notifications",
    description: "staff notification recipients section subtitle",
  },
  colName: {
    id: "a47o+d",
    defaultMessage: "Name",
    description: "customer name column",
  },
  colEmail: {
    id: "zYY9ob",
    defaultMessage: "Email",
    description: "email column",
  },
  colJoined: {
    id: "CX/GKO",
    defaultMessage: "Joined",
    description: "date joined column",
  },
  colUser: {
    id: "1FhF37",
    defaultMessage: "User",
    description: "linked staff user column",
  },
  colStatus: {
    id: "JPcLsv",
    defaultMessage: "Status",
    description: "recipient active status column",
  },
  statusActive: {
    id: "i4RxDe",
    defaultMessage: "Active",
    description: "recipient active status",
  },
  statusInactive: {
    id: "KYT/++",
    defaultMessage: "Inactive",
    description: "recipient inactive status",
  },
  noSubscribers: {
    id: "laa8uD",
    defaultMessage: "No newsletter subscribers found",
    description: "empty newsletter subscribers list",
  },
  noRecipients: {
    id: "oFJ8Qp",
    defaultMessage: "No staff email recipients found",
    description: "empty staff recipients list",
  },
  notLinked: {
    id: "3+ktnr",
    defaultMessage: "Not linked to a user",
    description: "recipient without linked user",
  },
  colActions: {
    id: "+DW1SC",
    defaultMessage: "Actions",
    description: "actions column",
  },
  addRecipient: {
    id: "m5SGXJ",
    defaultMessage: "Add recipient",
    description: "add staff notification recipient button",
  },
  addRecipientTitle: {
    id: "L4QwlE",
    defaultMessage: "Add email recipient",
    description: "add recipient dialog title",
  },
  emailLabel: {
    id: "nyvhXC",
    defaultMessage: "Email address",
    description: "recipient email field label",
  },
  activeLabel: {
    id: "EV0MCp",
    defaultMessage: "Active",
    description: "recipient active field label",
  },
  unsubscribe: {
    id: "04JleA",
    defaultMessage: "Unsubscribe",
    description: "unsubscribe customer button",
  },
  deleteRecipientTitle: {
    id: "Hr2T9i",
    defaultMessage: "Delete recipient",
    description: "delete recipient dialog title",
  },
  deleteRecipientText: {
    id: "BhJ6nj",
    defaultMessage: "Are you sure you want to remove {email} from email notifications?",
    description: "delete recipient dialog text",
  },
  unsubscribeTitle: {
    id: "NAwT1B",
    defaultMessage: "Unsubscribe customer",
    description: "unsubscribe dialog title",
  },
  unsubscribeText: {
    id: "nd9lu9",
    defaultMessage:
      "Are you sure you want to unsubscribe {name} from marketing emails? This clears their newsletter consent.",
    description: "unsubscribe dialog text",
  },
  recipientAdded: {
    id: "jqe9P8",
    defaultMessage: "Recipient added",
    description: "recipient added notification",
  },
  recipientUpdated: {
    id: "BIwHVx",
    defaultMessage: "Recipient updated",
    description: "recipient updated notification",
  },
  recipientDeleted: {
    id: "meYVJL",
    defaultMessage: "Recipient removed",
    description: "recipient removed notification",
  },
  unsubscribed: {
    id: "s1jigB",
    defaultMessage: "Customer unsubscribed",
    description: "customer unsubscribed notification",
  },
});
